import { ReactElement } from 'react';
import { translateFilterName } from 'b2b-apps/core/catalog/utils/facets';
import { translateFilterOption } from 'b2b-apps/core/catalog/utils/filters';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { Section } from './Section';
import {
  InjectedProps,
  Props,
} from './SectionContainer.types';

export const SectionContainer = (props: Props): ReactElement => {
  const t = useTranslate();
  const {
    filterGroup,
    onCheckboxChange,
  } = props;

  const handleOptionChange = (value: string): void => {
    onCheckboxChange(
      filterGroup.field,
      value,
    );
  };

  const handleTranslateFilterName = (filterFacet: string, name: string): string => (
    translateFilterName(t, filterFacet, name)
  );

  const handleTranslateFilterValue = (field: string, value: string): string => translateFilterOption(t, field, value);

  const injectedProps: InjectedProps = {
    onOptionChange: handleOptionChange,
    getFilterName: handleTranslateFilterName,
    getFilterValue: handleTranslateFilterValue,
  };

  return <Section {...props} {...injectedProps} />;
};
